import { createMuiTheme } from '@material-ui/core/styles';
import classes from './classes';

const primary = {
  main: '#05416B',
  dark: '#13808F',
  light: '#0A669E'
};

const secondary = {
  // main: '#19A796',
  main: '#13808F',
  dark: '#21C15A',
  light: '#1FC29B'
};

const error = {
  main: '#AB0731',
  dark: '#ED8514',
  light: '#C5CE17'
};

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontWeightRegular: 400, // 500
    fontFamily: ['Cairo', 'sans-serif']
  },
  palette: {
    primary,
    secondary,
    error
  },
  spacing: 3,
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  }
});

const white = {
  text: '#ffffff',
  primary: 'rgba(255, 255, 255, 0.7)',
  secondary: 'rgba(255, 255, 255, 0.54)',
  disabled: 'rgba(255, 255, 255, 0.38)',
  hint: 'rgba(255, 255, 255, 0.24)'
};

const red = {
  main: '#ff5252',
  dark: '#e04848'
};

const linked = {
  cursor: 'pointer',
  color: primary.main,
  display: 'inline-block'
};

const linkInverted = {
  ...linked,
  color: white.primary,
  '&:hover': {
    color: theme.palette.common.white
  }
};

export default {
  ...classes,
  theme,
  primary,
  red,
  linked,
  linkInverted,
  white
};
